document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('change', function (event) {
    const input = event.target;

    if (!(input instanceof HTMLInputElement)) {
      return;
    }

    if (!input.matches('.product-card input[data-variant-id]')) {
      return;
    }

    const productCard = input.closest('product-card');

    if (!productCard) {
      return;
    }

    const variantIdInput = productCard.querySelector('.yg-card-add-form__variant-id');

    if (!variantIdInput) {
      return;
    }

    variantIdInput.value = input.dataset.variantId || variantIdInput.value;
  });

  class YGMegaMenu extends HTMLElement {
    constructor() {
      super();
      this.tabs = null;
      this.items = null;
      this.buttons = null;
      this.tabHandlers = [];
      this.handleResize = this.handleResize.bind(this);
      this.init();
    }
    init() {
      this.tabs = this.querySelectorAll('.yg-collection-tab-item');
      this.items = this.querySelectorAll('.yg-right-box');
      this.buttons = this.querySelectorAll('.yg-collection-tab-item-button');
      if (this.tabs.length === 0 || this.items.length === 0) return;

      // 初始化高亮和展示
      this.tabs.forEach((tab, i) => {
        tab.classList.toggle('active', i === 0);
        if (this.items[i]) this.items[i].classList.toggle('active', i === 0);
      });
      this.updateViewAllButton(0);

      // 根据屏幕宽度设置事件
      this.handleResize();
      window.addEventListener('resize', this.handleResize);
    }

    switchTab(index) {
      this.tabs.forEach((t, j) => t.classList.toggle('active', index === j));
      this.items.forEach((p, j) => p.classList.toggle('active', index === j));
      this.updateViewAllButton(index);
    }

    updateViewAllButton(activeIndex) {
      if (!this.buttons || this.buttons.length === 0) return;

      this.buttons.forEach((btn, i) => {
        const isActive = i === activeIndex;
        btn.hidden = !isActive;
        btn.classList.toggle('active', isActive);
      });
    }

    handleResize() {
      const isMobile = window.innerWidth < 1150;

      // 清除现有事件监听器
      this.tabHandlers.forEach(({ tab, handler, type }) => {
        tab.removeEventListener(type, handler);
      });
      this.tabHandlers = [];

      // 根据设备类型添加事件
      this.tabs.forEach((tab, i) => {
        let handler;
        let type;

        if (isMobile) {
          // 移动端：点击切换
          type = 'click';
          handler = () => this.switchTab(i);
        } else {
          // 桌面端：悬浮切换
          type = 'mouseenter';
          handler = () => this.switchTab(i);
        }

        tab.addEventListener(type, handler);
        this.tabHandlers.push({ tab, handler, type });
      });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
      // 清除所有事件监听器
      this.tabHandlers.forEach(({ tab, handler, type }) => {
        tab.removeEventListener(type, handler);
      });
    }
  }
  if (!window.customElements.get('yg-mega-menu')) {
    window.customElements.define('yg-mega-menu', YGMegaMenu);
  }

  class YGGalleryButton extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const gallery = this.closest('.product-gallery');
      if (!gallery) return;
      
      // 查找对应的 media-carousel 元素
      const carousel = gallery.querySelector('media-carousel');
      if (!carousel) return;
      
      const leftBtn = this.querySelector('.yg-left-button');
      const rightBtn = this.querySelector('.yg-right-button');
      
      if (leftBtn) {
        leftBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          if (typeof carousel.previous === 'function') {
            carousel.previous();
          } else {
            carousel.dispatchEvent(new CustomEvent('control:prev', { bubbles: true }));
          }
        });
      }
      
      if (rightBtn) {
        rightBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          if (typeof carousel.next === 'function') {
            carousel.next();
          } else {
            carousel.dispatchEvent(new CustomEvent('control:next', { bubbles: true }));
          }
        });
      }
    }
  }

  if (!window.customElements.get('yg-gallery-button')) {
    window.customElements.define('yg-gallery-button', YGGalleryButton);
  }

  class YGBuyItNow extends HTMLElement {
    constructor() {
      super()
      this.init()
    }
    init() {
      // 这里放置初始化逻辑
      let _this = this
      let $button = _this.querySelector('.yg-buy-it-now-button')
      $button.addEventListener('click', () => _this.buttonClick())
    }
    buttonClick() {
      // 这里放置自定义逻辑
      let buyBtn = this.querySelector('.shopify-payment-button .shopify-payment-button__more-options') || this.querySelector('.shopify-payment-button .shopify-payment-button__button');
      buyBtn.click();
    }
  }
  if (!window.customElements.get('yg-buy-it-now')) {
    window.customElements.define('yg-buy-it-now', YGBuyItNow)
  }

  class YGAccordion extends YGUtils {
    constructor() {
      super();
      this.init();
    }

    init() {
      const header = this.querySelector(".yg-accordion-header");
      const content = this.querySelector(".yg-accordion-content");
      const trueHeight = content.scrollHeight;
      content.style.setProperty("--true-height", `${trueHeight}px`);
      header.addEventListener("click", () => { 
        this.classList.toggle("yg-accordion-open");
      });
    }
  }

  if (!window.customElements.get("yg-accordion")) {
    window.customElements.define("yg-accordion", YGAccordion);
  }

  const updateQuantitySelectorState = (selector) => {
    const input = selector.querySelector('.quantity-selector__input');
    const decreaseButton = selector.querySelector('.quantity-selector__button:first-of-type');

    if (!input || !decreaseButton) return;

    const min = Number(input.min || 1);
    const value = Number(input.value || min);
    decreaseButton.disabled = value <= min;
  };

  const updateAllQuantitySelectors = (scope = document) => {
    scope.querySelectorAll('quantity-selector').forEach(updateQuantitySelectorState);
  };

  updateAllQuantitySelectors();

  document.addEventListener('input', (event) => {
    const selector = event.target.closest?.('quantity-selector');
    if (selector) updateQuantitySelectorState(selector);
  });

  document.addEventListener('change', (event) => {
    const selector = event.target.closest?.('quantity-selector');
    if (selector) updateQuantitySelectorState(selector);
  });

  document.addEventListener('click', (event) => {
    const selector = event.target.closest?.('quantity-selector');
    if (!selector) return;

    requestAnimationFrame(() => updateQuantitySelectorState(selector));
  });

  document.addEventListener('product:rerender', (event) => {
    requestAnimationFrame(() => updateAllQuantitySelectors(event.target));
  });
})
